/**
 * §9.12 — Target job posting channels (`ggj_b2b_jobs.publish_channels` text[]).
 * Only **careers** is live in-product today; others are recorded intent for JOB-012 / workers.
 */

export const JOB_PUBLISH_CHANNEL_DEFS = [
  {
    id: 'careers',
    label: 'Organisation careers site',
    live: true,
    helper: 'Listed on /careers/{slug} when publish is Published and ops is Open (§9.11).',
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    live: false,
    helper: 'Planned — no OAuth / feed post in repo yet (JOB-012).',
  },
  {
    id: 'indeed',
    label: 'Indeed',
    live: false,
    helper: 'Planned — JOB-012.',
  },
  {
    id: 'naukri',
    label: 'Naukri',
    live: false,
    helper: 'Planned — JOB-012.',
  },
  {
    id: 'webhook',
    label: 'Partner webhook',
    live: false,
    helper: 'Planned — event on publish/unpublish (design TBD).',
  },
] as const;

export type JobPublishChannelId = (typeof JOB_PUBLISH_CHANNEL_DEFS)[number]['id'];

const ALLOWED_IDS = new Set<string>(JOB_PUBLISH_CHANNEL_DEFS.map((d) => d.id));

export function normalizeJobPublishChannels(raw: unknown): JobPublishChannelId[] {
  if (!Array.isArray(raw)) return [];
  const out: JobPublishChannelId[] = [];
  const seen = new Set<string>();
  for (const x of raw) {
    if (typeof x !== 'string' || !ALLOWED_IDS.has(x) || seen.has(x)) continue;
    seen.add(x);
    out.push(x as JobPublishChannelId);
  }
  return out;
}

export function metaForChannel(id: string): (typeof JOB_PUBLISH_CHANNEL_DEFS)[number] | undefined {
  return JOB_PUBLISH_CHANNEL_DEFS.find((d) => d.id === id);
}
